import styled from "styled-components";
import titleVector from "../../assets/images/titleVector.png";
export const FeaturesContainer = styled.section`
  /* width: 100%; */
  margin-bottom: 16rem;
  & > div {
    margin: 0 auto;
    margin-bottom: 9rem;
  }
  h2 {
    font-size: 4.8rem;
    font-weight: 80rem;
    text-align: center;
    color: var(--primary-color);
    margin-bottom: 8.6rem;
    background: url(${titleVector}) no-repeat 64.5% -50%;
    background-size: contain;
        @media (max-width: 560px) {
      font-size: 3.4rem;
    }
  }
  @media (max-width: 1024px) {
    padding: 2rem !important;
  }
`;
export const FeaturesCard = styled.div`
  width: 388px;
  display: flex;
  height: 150px;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 2.5rem;
  border-radius: 24px;
  /* box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25); */
  margin: 4rem 0;
`;
export const FeaturedCardContent = styled.div`
  h3 {
    font-size: 1.8rem;
    color: var(--title-color);
    font-weight: 50rem;
  }
  p {
    color: var(--text-color);
    font-size: 1.4rem;
    font-weight: 40rem;
  }
  @media (max-width: 450px) {
    h3 {
      font-size: 1.4rem;
    }
    p {
      font-size: 1.1rem;
    }
  }
`;
export const FeaturedIcons = styled.div`
  position: relative;
  & div:first-child {
    margin-left: 2rem;
  }
  & div:last-child {
    position: absolute;
    top: 20px;
    right: 42%;
  }
`;
